export const MuiInput = (palette) => ({
  underline: {
    '&:before': {
      borderBottom: `1px solid ${palette.primary.main}`,
    },
    '&&&&:not($disabled):hover:before': {
      borderBottom: `2px solid ${palette.primary.main}`,
    },
    '&$disabled:before': {
      'borderBottom': `1px solid ${palette.primary.light}`,
      'border-bottom-style': 'solid',
    },
    '&$focused': {
      '&:after': {
        borderBottom: `1px solid ${palette.primary.main}`,
      },
    },
  },
})
